export const CAMPAIGN_STEP_TITLES = {
  details: "Details",
  bill: "Bill",
  preview: "Preview",
  schedule: "Schedule",
  budget: "Budget",
  review: "Review",
};

/** Matches backend create grace in campaign_list_create (~5 minutes). */
export const CREATE_START_PAST_GRACE_MS = 5 * 60 * 1000;

export const STALE_SCHEDULE_START_ISSUE = {
  step: "schedule",
  message: "The start time has already passed. Pick a new start and end.",
};

export function isCreateStartTooFarInPast(startDate, nowMs = Date.now()) {
  if (!startDate || Number.isNaN(startDate.getTime())) return false;
  return startDate.getTime() < nowMs - CREATE_START_PAST_GRACE_MS;
}

export function getStaleStartScheduleIssue(scheduleLocked, startDate) {
  if (scheduleLocked) return null;
  if (isCreateStartTooFarInPast(startDate)) return STALE_SCHEDULE_START_ISSUE;
  return null;
}

export function getPublishIssuesFromError(error) {
  const data = error?.response?.data;
  if (!data || !Array.isArray(data.publish_issues)) {
    return null;
  }
  return data.publish_issues.filter(
    (item) => item && typeof item.step === "string" && typeof item.message === "string"
  );
}

export function getStaleStartIssueFromApiError(error) {
  const data = error?.response?.data;
  const message = String(data?.error || data?.detail || error?.message || "").toLowerCase();
  if (message.includes("start_datetime") && message.includes("past")) {
    return STALE_SCHEDULE_START_ISSUE;
  }
  return null;
}

export function resolvePublishIssuesFromError(error) {
  const fromPublish = getPublishIssuesFromError(error);
  if (fromPublish && fromPublish.length > 0) return fromPublish;
  const stale = getStaleStartIssueFromApiError(error);
  return stale ? [stale] : null;
}

export function hasPublishIssuesError(error) {
  const issues = resolvePublishIssuesFromError(error);
  return Boolean(issues && issues.length > 0);
}
